module.exports = __webpack_public_path__ + "img/manage-replace-icon.8f30edca.svg";